<template>
  <div class="Ssheader">
    <nav class="navbar container is-fluid">
      <div class="navbar-brand">
        <a class="navbar-item" href="/">
          <img src="/static/sarikayaSahinLogo.png" alt="Sarıkayaşahin Hukuk">
        </a>
      </div>
      <div class="navbar-menu navk" :class="{ navMenu: navMenu }">

        <router-link :class="{ active: menu.isActive }" v-for="menu in menuData" :key="`${menu.index}`" :to="`/${menu.path}`" class="navbar-item " @click.native="navMenu = !navMenu">{{menu.name}}</router-link>

      </div>
      <div class="navbar-burger" @click="navMenu = !navMenu">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </nav>
  </div>
</template>

<script>

  export default {
    components: {
    },
    name: 'tr-header',
    data() {
      return {
        menuData: [
          { name: 'Anasayfa', path: 'tr', isActive: false, a: 'activate' },
          { name: 'Hakkımızda', path: 'tr/hakkimizda', isActive: false },
          { name: 'Faalİyet Alanları', path: 'tr/hukuk-faaliyet-alanlari', isActive: false },
          { name: 'EKİBİMİZ', path: 'tr/ekibimiz', isActive: false },
          { name: 'BÜLTEN', path: 'tr/bulten', isActive: false },
          { name: 'YAYINLAR', path: 'tr/yayinlar', isActive: false },
          { name: 'İletİşİm', path: 'tr/iletisim', isActive: false },
          { name: 'TR', path: 'tr', isActive: false },
          { name: 'EN', path: '', isActive: false },
        ],
        navMenu: false
      }
    },
    methods: {
      activate: function() {
        this.navMenu = !navMenu;
        console.log(this.navMenu)
      }
    },
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// header.vue?39ae4ef1